import { useUserOrganizations } from '@/organization/useOrganizations';
import { Organization } from '@/types/organization';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrg } from './useOrg';

export function OrganizationSwitcher() {
  const { selectedOrg, setSelectedOrg } = useOrg();
  const { data, isLoading } = useUserOrganizations();
  const navigate = useNavigate();
  const orgs: Organization[] = React.useMemo(
    () => (Array.isArray(data) ? data : []),
    [data],
  );

  if (isLoading || !orgs) return null;
  if (orgs.length === 1) return <span>{orgs[0].name}</span>;

  return (
    <FormControl>
      <InputLabel>Select Org</InputLabel>
      <Select
        value={selectedOrg?.id ?? ''}
        onChange={(e) => {
          const org = orgs.find((o: Organization) => o.id === e.target.value);
          if (org) {
            setSelectedOrg(org);
            navigate(`/landing`);
          }
        }}
        label='Select Org'
        size={'small'}
        variant={'outlined'}
        sx={{
          color: 'primary.contrastText',
          bgcolor: 'primary.dark',
          minWidth: 140,
          '.MuiSelect-icon': { color: 'primary.contrastText' },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.contrastText',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'secondary.light',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: 'primary.dark',
              color: 'primary.contrastText',
              '& .MuiMenuItem-root': {
                bgcolor: 'primary.dark',
                color: 'primary.contrastText',
                '&:hover, &:focus': {
                  bgcolor: 'primary.main',
                  color: 'secondary.light',
                },
              },
              '& .MuiList-root': {
                bgcolor: 'primary.dark',
                paddingTop: 0,
                paddingBottom: 0,
              },
            },
          },
        }}
      >
        {orgs.map((org: Organization) => (
          <MenuItem
            key={org.id}
            value={org.id}
            sx={{
              bgcolor: 'primary.dark',
              color: 'primary.contrastText',
              '&:hover, &:focus': {
                bgcolor: 'primary.main',
                color: 'secondary.light',
              },
            }}
          >
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
